import { ChevronRightIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Button from "../../../../components/ui/Button/Button";
import Modal from "../../../../components/ui/Modal/Modal";
import PopupCancelOrder from "./PopupCancelOrder";
import InvoiceEditModal from "./InvoiceEditModal";
import QRModal from "../../../DefectReception/Components/QRModal";
import { useCompleteDelivery } from "../../../../api/order-management/use-complete-delivery";
import { usePostStatusAction } from "../../../../api/order-management/use-action-order";
import { useCompleteOrder } from "../../../../api/order-management/use-order-complete";
import { useDeliveryTracking } from "../../../../api/delivery-tracking/use-delivery-tracking";
import { useCancelOrderPayment } from "../../../../api/order-management/use-order-cancel-payment";

const DetailTable = (props) => {
  const totalSteps = 5;
  const { productOrders, orderDetailData } = props;
  const [invoiceNo, setInvoiceNo] = useState("");
  const [isTrackingModalOpen, setIsTrackingModalOpen] = useState(false);
  const [closeEditInvoice, setCloseEditInvoice] = useState(false);
  const [triggerCloseQrModal, setTriggerCloseQrModal] = useState(false);
  const [triggerCloseEditModal, setTriggerCloseEditModal] = useState(false);
  const [triggerCloseActionModal, setTriggerCloseActionModal] = useState(false);
  const { mutate: completeDelivery } = useCompleteDelivery();
  const { mutate: postStatusAction } = usePostStatusAction();
  const { mutate: completeOrder } = useCompleteOrder();
  const { mutateAsync: cancelOrderPayment } = useCancelOrderPayment();

  const {
    data: deliveryTrackingData,
    isLoading: isDeliveryTrackingLoading,
    isError: isDeliveryTrackingError,
    error: deliveryTrackingError,
  } = useDeliveryTracking(invoiceNo);
  const paidType = orderDetailData?.paymentInformation?.paidType;

  useEffect(() => {
    if (triggerCloseQrModal === true) {
      setTriggerCloseQrModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerCloseQrModal]);

  useEffect(() => {
    if (triggerCloseEditModal === true) {
      setTriggerCloseEditModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerCloseEditModal]);

  useEffect(() => {
    if (triggerCloseActionModal === true) {
      setTriggerCloseActionModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerCloseActionModal]);

  const onCloseQrModal = () => {
    setTriggerCloseQrModal(true);
  };

  const handleCompleteDelivery = async (productOrderId) => {
    await completeDelivery(productOrderId);
  };

  const handleOpenDeliveryTracking = (selectedInvoiceNo) => {
    setInvoiceNo(selectedInvoiceNo || "");
    setIsTrackingModalOpen(true);
  };

  const handleApproveReturn = async (productOrderId) => {
    const action = "APPROVE_RETURN";
    await postStatusAction({ action, productOrderId });
    setTriggerCloseActionModal(true);
    window.location.reload();
  };
  const handleRejectReturn = async (productOrderId) => {
    const action = "REJECT_RETURN";
    await postStatusAction({ action, productOrderId });
    await completeOrder({ action, productOrderId });
    setTriggerCloseActionModal(true);
    window.location.reload();
  };
  const handleApproveCancel = async (productOrderId) => {
    const action = "APPROVE_CANCEL";
    try {
      await cancelOrderPayment(productOrderId);
    } catch {
      toast.error("결제취소가 실패하였습니다.");
      return;
    }
    await postStatusAction({ action, productOrderId });
    await completeOrder({ action, productOrderId });
    setTriggerCloseActionModal(true);
    window.location.reload();
  };
  const handleRejectCancel = async (productOrderId) => {
    const action = "REJECT_CANCEL";
    await postStatusAction({ action, productOrderId });
    setTriggerCloseActionModal(true);
    window.location.reload();
  };
  const handleApproveExchange = async (productOrderId) => {
    const action = "APPROVE_EXCHANGE";
    await postStatusAction({ action, productOrderId });
    setTriggerCloseActionModal(true);
    window.location.reload();
  };
  const handleRejectExchange = async (productOrderId) => {
    const action = "REJECT_EXCHANGE";
    await postStatusAction({ action, productOrderId });
    await completeOrder({ action, productOrderId });
    setTriggerCloseActionModal(true);
    window.location.reload();
  };
  const handleDeliveryExchangeFinish = async (productOrderId) => {
    const action = "DELIVERY_EXCHANGE_FINISH";
    await postStatusAction({ action, productOrderId });
    await completeOrder({ action, productOrderId });
    setTriggerCloseActionModal(true);
    window.location.reload();
  };
  const handleFinishReturn = async (productOrderId) => {
    const action = "FINISH_RETURN";
    // 신용카드: PG 결제취소 후 서버 완료 처리
    // 무통장입금: 오프라인 계좌이체 환급 후 서버 완료 처리만 수행
    if (paidType === "CREDIT") {
      try {
        await cancelOrderPayment(productOrderId);
      } catch {
        toast.error("결제취소가 실패하였습니다.");
        return;
      }
    }
    await postStatusAction({ action, productOrderId });
    await completeOrder({ action, productOrderId });
    setTriggerCloseActionModal(true);
    window.location.reload();
  };

  const renderDeliveryTrackingData = () => {
    if (isDeliveryTrackingLoading) {
      return <p className="px-4 py-3">배송추적 정보를 조회 중입니다.</p>;
    }

    if (isDeliveryTrackingError) {
      return (
        <p className="px-4 py-3 text-[#e80000]">
          배송추적 조회에 실패했습니다.
          {deliveryTrackingError?.message
            ? ` (${deliveryTrackingError.message})`
            : ""}
        </p>
      );
    }

    if (!deliveryTrackingData) {
      return <p className="px-4 py-3">조회된 배송추적 정보가 없습니다.</p>;
    }

    const normalizedTrackingData =
      deliveryTrackingData?.data ||
      deliveryTrackingData?.result ||
      deliveryTrackingData;

    if (normalizedTrackingData?.resultCode !== "OK") {
      return (
        <div className="px-4 py-3 text-[12px]">
          <p className="mb-2">
            <span className="font-bold">운송장번호</span> :{" "}
            {normalizedTrackingData?.wblNo || invoiceNo || "-"}
          </p>
          <p className="text-[#e80000]">
            [{normalizedTrackingData?.resultCode || "-"}]{" "}
            {normalizedTrackingData?.resultMessage || "-"}
          </p>
        </div>
      );
    }

    const trackingList = Array.isArray(normalizedTrackingData?.wrkList)
      ? normalizedTrackingData.wrkList
      : [];

    return (
      <div className="text-[12px]">
        <div className="mb-3 rounded-[4px] bg-[#f5f5f5] p-3">
          <p>
            <span className="font-bold">송장번호</span> :{" "}
            {normalizedTrackingData?.wblNo || "-"}
          </p>
          <p>
            <span className="font-bold">주문번호</span> :{" "}
            {normalizedTrackingData?.custOrdNo || "-"}
          </p>
        </div>

        {trackingList.length === 0 ? (
          <p className="px-1 py-2">배송 이력 정보가 없습니다.</p>
        ) : (
          <div className="max-h-[24rem] overflow-auto border border-light-grey rounded-[4px]">
            <table className="w-full text-left text-[11px]">
              <thead className="bg-input-grey">
                <tr>
                  <th className="border border-light-grey p-2">상태</th>
                  <th className="border border-light-grey p-2">일시</th>
                  <th className="border border-light-grey p-2">대리점</th>
                  <th className="border border-light-grey p-2">담당자</th>
                  <th className="border border-light-grey p-2">설명</th>
                </tr>
              </thead>
              <tbody>
                {trackingList.map((track, index) => (
                  <tr key={`${track?.statusDate || "date"}-${index}`}>
                    <td className="border border-light-grey p-2">
                      {track?.statusName || "-"}
                    </td>
                    <td className="border border-light-grey p-2">
                      {track?.statusDate || "-"}
                    </td>
                    <td className="border border-light-grey p-2">
                      {track?.agencyName || "-"}
                      {track?.agencyTel ? ` (${track.agencyTel})` : ""}
                    </td>
                    <td className="border border-light-grey p-2">
                      {track?.workerName || "-"}
                      {track?.workerTel ? ` (${track.workerTel})` : ""}
                    </td>
                    <td className="border border-light-grey p-2">
                      {track?.description || "-"}
                      {track?.reasonMessage
                        ? ` / 사유: ${track.reasonMessage}`
                        : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <div>
        총 <span className="font-bold">{productOrders?.length}</span>건
      </div>
      <Modal
        title="배송추적 조회"
        maxWidth="max-w-[72rem]"
        width="w-[92vw]"
        height="h-[60vh]"
        padding="p-0"
        hasClose={true}
        hasCancel={false}
        hasSubmit={false}
        isOpenFromOutside={isTrackingModalOpen}
        setIsOpenFromOutside={setIsTrackingModalOpen}
        description={<div className="p-4">{renderDeliveryTrackingData()}</div>}
      >
        <span className="hidden" />
      </Modal>
      {productOrders?.length > 0 ? (
        <>
          <table className="w-full text-center mt-2 text-[12px]">
            <thead>
              <tr className="bg-input-grey">
                <th className="border border-disable-grey p-2">번호</th>
                <th className="border border-disable-grey p-2">상품명</th>
                <th className="border border-disable-grey p-2">
                  상품코드(REF)
                </th>
                <th className="border border-disable-grey p-2">결제금액</th>
                <th className="border border-disable-grey p-2">주문 수량</th>
                <th className="border border-disable-grey p-2">발송 수량</th>
                <th className="border w-36 border-disable-grey p-2">
                  택배사/송장번호
                </th>
                <th className="border border-disable-grey p-1.5 w-[5rem]">
                  배송 상태
                </th>
                <th className="border border-disable-grey p-1.5">비고</th>
              </tr>
            </thead>
            <tbody>
              {productOrders?.map((item, index) => {
                const shipmentQty = item?.productDeliveries?.map((res) =>
                  res?.productDeliveryDetail?.reduce((a, b) => a + b.qnt, 0)
                );
                const summedShipmentQty = shipmentQty?.reduce(
                  (a, b) => a + b,
                  0
                );
                const summedAllShipmentQty = productOrders?.reduce(
                  (a, b) =>
                    a +
                    b.productDeliveries?.reduce(
                      (a, b) =>
                        a +
                        b?.productDeliveryDetail?.reduce(
                          (a, b) => a + b.qnt,
                          0
                        ),
                      0
                    ),
                  0
                );
                const isNotExchangedReview =
                  item?.status?.includes("EXCHANGED") &&
                  item?.replaceConfirmedAt !== null;
                const productDeliveries = isNotExchangedReview
                  ? item?.productDeliveries?.filter(
                      (res) => res?.isExchanged === true
                    )
                  : item?.productDeliveries;
                const hasProdDelivery = productDeliveries?.length > 0;
                const rowSpanInTable = () => {
                  if (productDeliveries?.length === 0) {
                    return 2;
                  } else {
                    if (summedShipmentQty < item?.quantity) {
                      return productDeliveries?.length + 2;
                    } else {
                      return productDeliveries?.length + 1;
                    }
                  }
                };
                return (
                  <React.Fragment key={item.id ?? `product-order-${index}`}>
                    <tr key={item.id}>
                      <td
                        rowSpan={rowSpanInTable() + 1}
                        className="h-40 px-4 w-12 border border-light-grey py-8 text-center"
                      >
                        {index + 1}
                      </td>
                      <td
                        rowSpan={rowSpanInTable()}
                        className="border border-light-grey px-4 text-center"
                      >
                        {item?.productName}
                      </td>
                      <td
                        rowSpan={rowSpanInTable()}
                        className="px-4 border border-light-grey text-center"
                      >
                        {item?.productCode}
                      </td>
                      <td
                        rowSpan={rowSpanInTable()}
                        className=" border border-light-grey text-center"
                      >
                        {Math.round(item?.paymentAmount).toLocaleString("KR")}
                      </td>
                      <td
                        rowSpan={rowSpanInTable()}
                        className=" border border-light-grey text-center"
                      >
                        {item?.quantity}
                      </td>
                    </tr>
                    {hasProdDelivery ? (
                      productDeliveries?.map((res, index) => {
                        return (
                          <React.Fragment
                            key={
                              res?.id ?? `delivery-${item.id ?? index}-${index}`
                            }
                          >
                            <tr>
                              <td
                                className={`border border-light-grey p-4 ${
                                  isNotExchangedReview ? "text-[#0054ff]" : ""
                                }`}
                              >
                                {item?.status?.includes("EXCHANGED") &&
                                item?.status === "EXCHANGED_SHIPPING" ? (
                                  <span className="text-[#0054ff]">0</span>
                                ) : (
                                  res?.productDeliveryDetail?.reduce(
                                    (a, b) => a + b.qnt,
                                    0
                                  )
                                )}
                              </td>
                              <td
                                className={`border border-light-grey p-4  ${
                                  isNotExchangedReview ? "text-[#0054ff]" : ""
                                }`}
                              >
                                {!item?.status?.includes("EXCHANGED") &&
                                  item?.status !== "PAYMENT_COMPLETED" &&
                                  item?.status !== "DEPOSIT_WAITING" && (
                                    <span>
                                      {res?.deliveryCompanyName}
                                      <br />
                                      {res?.invoiceNo}
                                    </span>
                                  )}
                                {item?.status?.includes("EXCHANGED") &&
                                  item?.status !== "EXCHANGED_SHIPPING" && (
                                    <span>
                                      {res?.deliveryCompanyName}
                                      <br />
                                      {res?.invoiceNo}
                                    </span>
                                  )}

                                {item?.status?.includes("EXCHANGED") &&
                                  item?.status === "EXCHANGED_SHIPPING" && (
                                    <Modal
                                      padding="p-0"
                                      hasSubmit={false}
                                      hasCancel={false}
                                      maxWidth="max-w-[48rem]"
                                      description={
                                        <QRModal
                                          confirmModal={`입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다.`}
                                          id={item?.productId}
                                          productData={item}
                                          onCloseQrModal={onCloseQrModal}
                                          remainingQty={
                                            item?.quantity -
                                            (summedShipmentQty ?? 0)
                                          }
                                          isExchanged={true}
                                        />
                                      }
                                      triggerClose={triggerCloseQrModal}
                                    >
                                      <Button
                                        width="w-[70px]"
                                        margin="m-0"
                                        text={`등록`}
                                        paddingButton="py-1"
                                        borderColor="border border-background-blue"
                                        textColorDefault="text-background-blue"
                                      />
                                    </Modal>
                                  )}
                              </td>
                              <td
                                className={`w-20 border border-light-grey text-center  ${
                                  isNotExchangedReview ? "text-[#0054ff]" : ""
                                }`}
                              >
                                {!item?.status?.includes("EXCHANGED") &&
                                  item?.status !== "PAYMENT_COMPLETED" &&
                                  item?.status !== "DEPOSIT_WAITING" && (
                                    <div
                                      className={`${
                                        item.exchange === true &&
                                        item.step !== 2
                                          ? "text-secondary-blue"
                                          : "text-black"
                                      }`}
                                    >
                                      <span
                                        className={`mb-1 block  ${
                                          isNotExchangedReview
                                            ? "text-[#0054ff]"
                                            : ""
                                        }`}
                                      >
                                        전체 배송
                                      </span>
                                      <Modal
                                        maxWidth="max-w-[26rem]"
                                        padding="p-0"
                                        hasCancel={false}
                                        hasSubmit={false}
                                        description={
                                          <div className="px-5 pt-2 pb-1">
                                            송장번호를 수정하시겠습니까?
                                            <br />
                                            1. 수정할 경우 - '송장번호 수정'
                                            선택
                                            <br />
                                            2. 배송추적 확인할 경우 - '배송추적
                                            확인' 선택
                                            <div className="-mb-2.5 flex justify-end mt-3">
                                              <Modal
                                                padding="p-0"
                                                maxWidth="max-w-[50rem]"
                                                hasCancel={false}
                                                hasSubmit={false}
                                                triggerClose={closeEditInvoice}
                                                description={
                                                  <InvoiceEditModal
                                                    productData={item}
                                                    shipmentData={res}
                                                    setCloseModal={
                                                      setCloseEditInvoice
                                                    }
                                                    setTriggerCloseEditModal={
                                                      setTriggerCloseEditModal
                                                    }
                                                  />
                                                }
                                              >
                                                <button className="bg-primary-blue mr-2 px-3 py-1 rounded-[4px] text-white border border-primary-blue">
                                                  송장번호 수정
                                                </button>
                                              </Modal>

                                              <button
                                                className="bg-primary-blue px-3 text-white rounded-[4px] border border-primary-blue"
                                                onClick={() =>
                                                  handleOpenDeliveryTracking(
                                                    res?.invoiceNo
                                                  )
                                                }
                                              >
                                                배송추적 확인
                                              </button>
                                            </div>
                                          </div>
                                        }
                                        triggerClose={triggerCloseEditModal}
                                      >
                                        <Button
                                          paddingButton="py-0.5"
                                          margin="mx-2"
                                          borderColor="border border-secondary-grey"
                                          textColorDefault="text-dark-grey"
                                          width="w-16"
                                          text={`배송추적`}
                                        />
                                      </Modal>
                                    </div>
                                  )}
                                {item?.status?.includes("EXCHANGED") &&
                                  item?.status !== "EXCHANGED_SHIPPING" && (
                                    <div
                                      className={`${
                                        item.exchange === true &&
                                        item.step !== 2
                                          ? "text-secondary-blue"
                                          : "text-black"
                                      }`}
                                    >
                                      <span
                                        className={`mb-1  ${
                                          isNotExchangedReview
                                            ? "text-[#0054ff]"
                                            : ""
                                        }`}
                                      >
                                        전체 배송
                                      </span>
                                      <Modal
                                        maxWidth="max-w-[26rem]"
                                        padding="p-0"
                                        hasCancel={false}
                                        hasSubmit={false}
                                        description={
                                          <div className="px-5 pt-2 pb-1">
                                            송장번호를 수정하시겠습니까?
                                            <br />
                                            1. 수정할 경우 - '송장번호 수정'
                                            선택
                                            <br />
                                            2. 배송추적 확인할 경우 - '배송추적
                                            확인' 선택
                                            <div className="-mb-2.5 flex justify-end mt-3">
                                              <Modal
                                                padding="p-0"
                                                maxWidth="max-w-[50rem]"
                                                hasCancel={false}
                                                hasSubmit={false}
                                                triggerClose={closeEditInvoice}
                                                description={
                                                  <InvoiceEditModal
                                                    productData={item}
                                                    shipmentData={res}
                                                    setCloseModal={
                                                      setCloseEditInvoice
                                                    }
                                                    setTriggerCloseEditModal={
                                                      setTriggerCloseEditModal
                                                    }
                                                  />
                                                }
                                              >
                                                <button className="bg-primary-blue mr-2 px-3 py-1 rounded-[4px] text-white border border-primary-blue">
                                                  송장번호 수정
                                                </button>
                                              </Modal>

                                              <button
                                                className="bg-primary-blue px-3 text-white rounded-[4px] border border-primary-blue"
                                                onClick={() =>
                                                  handleOpenDeliveryTracking(
                                                    res?.invoiceNo
                                                  )
                                                }
                                              >
                                                배송추적 확인
                                              </button>
                                            </div>
                                          </div>
                                        }
                                        triggerClose={triggerCloseEditModal}
                                      >
                                        <Button
                                          paddingButton="py-0.5"
                                          margin="mx-2"
                                          borderColor="border border-secondary-grey"
                                          textColorDefault="text-dark-grey"
                                          width="w-16"
                                          text={`배송추적`}
                                        />
                                      </Modal>
                                    </div>
                                  )}
                              </td>
                              <td className="w-[5.5rem] border border-light-grey text-center">
                                {item?.status?.includes("RETURNED") && (
                                  <Modal
                                    maxWidth="max-w-[29rem]"
                                    padding="p-0"
                                    widthButton="w-full py-1.5 mx-2"
                                    widthSubmitButton="w-full py-1.5 mx-2"
                                    title="반품요청 상세 내역"
                                    hasClose={true}
                                    hasCancel={false}
                                    cancelText="전체 다운로드"
                                    submitText="교환요청"
                                    paddingTitle={`px-4 pt-4`}
                                    hasSubmit={false}
                                    description={
                                      <PopupCancelOrder
                                        isSubmit={false}
                                        data={item?.complaints[0]}
                                      />
                                    }
                                    onSubmit={() => {}}
                                  >
                                    <button className="border text-[#555555] border-secondary-grey px-2.5 py-0.5 rounded-[4px]">
                                      반품상세
                                    </button>
                                  </Modal>
                                )}
                                {item?.status?.includes("EXCHANGED") && (
                                  <Modal
                                    maxWidth="max-w-[29rem]"
                                    padding="p-0"
                                    widthButton="w-full py-1.5 mx-2"
                                    widthSubmitButton="w-full py-1.5 mx-2"
                                    title="교환요청 상세 내역"
                                    hasClose={true}
                                    hasCancel={false}
                                    cancelText="전체 다운로드"
                                    submitText="교환요청"
                                    paddingTitle={`px-4 pt-4`}
                                    hasSubmit={false}
                                    description={
                                      <PopupCancelOrder
                                        isSubmit={false}
                                        data={item?.complaints?.[0]}
                                      />
                                    }
                                  >
                                    <button className="border text-[#555555] border-secondary-grey px-2.5 py-0.5 rounded-[4px]">
                                      교환상세
                                    </button>
                                  </Modal>
                                )}
                                {item?.status === "CANCELED" && (
                                  <Modal
                                    maxWidth="max-w-[29rem]"
                                    padding="p-0"
                                    widthButton="w-full py-1.5 mx-2"
                                    widthSubmitButton="w-full py-1.5 mx-2"
                                    title={`취소요청 상세 내역`}
                                    hasClose={true}
                                    hasCancel={false}
                                    cancelText="전체 다운로드"
                                    submitText="취소요청"
                                    paddingTitle={`px-4 pt-4`}
                                    hasSubmit={false}
                                    description={
                                      <PopupCancelOrder
                                        isSubmit={false}
                                        data={item?.complaints[0]}
                                      />
                                    }
                                    onSubmit={() => {}}
                                  >
                                    <button className="border text-[#555555] border-secondary-grey px-2.5 py-0.5 rounded-[4px]">
                                      취소상세
                                    </button>
                                  </Modal>
                                )}
                              </td>
                            </tr>
                            {index === item?.productDeliveries?.length - 1 &&
                              summedShipmentQty < item?.quantity && (
                                <tr>
                                  <td className="border border-light-grey p-4">
                                    {/* {item?.quantity - summedShipmentQty} */}
                                    0
                                  </td>
                                  <td className="border border-light-grey p-4">
                                    {item?.status === "PAYMENT_COMPLETED" ||
                                      (item?.status === "SHIPPING" && (
                                        <Modal
                                          padding="p-0"
                                          hasSubmit={false}
                                          hasCancel={false}
                                          maxWidth="max-w-[48rem]"
                                          description={
                                            <QRModal
                                              confirmModal={`입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다.`}
                                              id={item?.productId}
                                              productData={item}
                                              onCloseQrModal={onCloseQrModal}
                                              remainingQty={
                                                item?.quantity -
                                                (summedShipmentQty ?? 0)
                                              }
                                            />
                                          }
                                          triggerClose={triggerCloseQrModal}
                                        >
                                          <Button
                                            width="w-[70px]"
                                            margin="m-0"
                                            text={`등록`}
                                            paddingButton="py-1"
                                            borderColor="border border-background-blue"
                                            textColorDefault="text-background-blue"
                                          />
                                        </Modal>
                                      ))}
                                    {item?.status?.includes("EXCHANGED") &&
                                      item?.status === "EXCHANGED_SHIPPING" && (
                                        <Modal
                                          padding="p-0"
                                          hasSubmit={false}
                                          hasCancel={false}
                                          maxWidth="max-w-[48rem]"
                                          description={
                                            <QRModal
                                              confirmModal={`입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다.`}
                                              id={item?.productId}
                                              productData={item}
                                              onCloseQrModal={onCloseQrModal}
                                              remainingQty={
                                                item?.quantity -
                                                (summedShipmentQty ?? 0)
                                              }
                                            />
                                          }
                                          triggerClose={triggerCloseQrModal}
                                        >
                                          <Button
                                            width="w-[70px]"
                                            margin="m-0"
                                            text={`등록`}
                                            paddingButton="py-1"
                                            borderColor="border border-background-blue"
                                            textColorDefault="text-background-blue"
                                          />
                                        </Modal>
                                      )}
                                  </td>
                                  <td className="border border-light-grey p-4"></td>
                                  <td className="border border-light-grey p-4"></td>
                                </tr>
                              )}
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td className="border border-light-grey p-4">
                          {item?.status?.includes("CANCELED") &&
                            item?.cancelRejectedAt !== null &&
                            0}
                          {item?.status?.includes("EXCHANGED") &&
                            item?.replaceConfirmedAt !== null && (
                              <span className="text-[#0054ff]">0</span>
                            )}
                        </td>
                        <td className="border border-light-grey p-4">
                          {
                            // item?.shipmentQuantity <
                            (item?.status === "PAYMENT_COMPLETED" ||
                              item?.status === "SHIPPING" ||
                              item?.status?.includes("EXCHANGED") ||
                              (item?.status?.includes("CANCELED") &&
                                item?.cancelRejectedAt !== null)) &&
                              productDeliveries?.length === 0 && (
                                <Modal
                                  padding="p-0"
                                  hasSubmit={false}
                                  hasCancel={false}
                                  maxWidth="max-w-[48rem]"
                                  description={
                                    <QRModal
                                      confirmModal={`입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다.`}
                                      id={item?.productId}
                                      productData={item}
                                      onCloseQrModal={onCloseQrModal}
                                      remainingQty={
                                        item?.quantity -
                                        (summedShipmentQty ?? 0)
                                      }
                                      isExchanged={item?.status?.includes(
                                        "EXCHANGED"
                                      )}
                                    />
                                  }
                                  triggerClose={triggerCloseQrModal}
                                >
                                  <Button
                                    width="w-[70px]"
                                    margin="m-0"
                                    text={`등록`}
                                    paddingButton="py-1"
                                    borderColor="border border-background-blue"
                                    textColorDefault="text-background-blue"
                                  />
                                </Modal>
                              )
                          }
                        </td>
                        <td className="border border-light-grey p-4"></td>
                        <td className="border border-light-grey p-4">
                          {item?.status === "CANCELED" && (
                            <Modal
                              maxWidth="max-w-[29rem]"
                              padding="p-0"
                              widthButton="w-full py-1.5 mx-2"
                              widthSubmitButton="w-full py-1.5 mx-2"
                              title={`취소요청 상세 내역`}
                              hasClose={true}
                              hasCancel={false}
                              cancelText="전체 다운로드"
                              submitText="취소요청"
                              paddingTitle={`px-4 pt-4`}
                              hasSubmit={false}
                              description={
                                <PopupCancelOrder
                                  isSubmit={false}
                                  data={item?.complaints[0]}
                                />
                              }
                              onSubmit={() => {}}
                            >
                              <button className="border text-[#555555] border-secondary-grey px-2.5 py-0.5 rounded-[4px]">
                                취소상세
                              </button>
                            </Modal>
                          )}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td
                        colSpan={8}
                        className="w-20 h-[4rem] border border-disable-grey bg-drop-blue text-center"
                      >
                        <div className="flex justify-between items-center px-4">
                          <div className="flex space-x-5 font-bold">
                            {[...Array(totalSteps)].map((_, index) => (
                              <React.Fragment key={index}>
                                {item?.status?.includes("RETURNED")
                                  ? index > 0 &&
                                    index < 4 && (
                                      <div>
                                        <ChevronRightIcon className="w-4" />
                                      </div>
                                    )
                                  : index > 0 && (
                                      <div>
                                        <ChevronRightIcon className="w-4" />
                                      </div>
                                    )}
                                <div
                                  className={`${
                                    item.step >= index + 1
                                      ? "font-bold text-black"
                                      : "font-bold text-secondary-grey"
                                  }`}
                                >
                                  {!item?.status.includes("RETURNED") &&
                                  !item?.status.includes("EXCHANGED") &&
                                  !item?.status.includes("CANCELED") ? (
                                    <div>
                                      {index + 1 === 1 && (
                                        <span className="font-bold text-black">
                                          입금대기
                                        </span>
                                      )}
                                      {index + 1 === 2 && (
                                        <span
                                          className={`${
                                            item?.status !==
                                              "DEPOSIT_WAITING" ||
                                            (item?.status === "CANCELED" &&
                                              item?.paymentSuccessAt !== null)
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          결제완료
                                        </span>
                                      )}
                                      {index + 1 === 3 && (
                                        <span
                                          className={`${
                                            item?.status !==
                                              "DEPOSIT_WAITING" &&
                                            item?.status !== "PAYMENT_COMPLETED"
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          배송중
                                        </span>
                                      )}
                                      {index + 1 === 4 && (
                                        <span
                                          className={`${
                                            item?.status !==
                                              "DEPOSIT_WAITING" &&
                                            item?.status !==
                                              "PAYMENT_COMPLETED" &&
                                            item?.status !== "SHIPPING"
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          배송완료
                                        </span>
                                      )}
                                      {index + 1 === 5 && (
                                        <span
                                          className={`${
                                            item?.status !==
                                              "DEPOSIT_WAITING" &&
                                            item?.status !==
                                              "PAYMENT_COMPLETED" &&
                                            item?.status !== "SHIPPING" &&
                                            item?.status !==
                                              "DELIVERY_COMPLETED"
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          구매확정
                                        </span>
                                      )}
                                    </div>
                                  ) : null}

                                  {item?.status === "CANCELED" ? (
                                    <div>
                                      {index + 1 === 1 && (
                                        <span className="font-bold text-black">
                                          입금대기
                                        </span>
                                      )}
                                      {index + 1 === 2 && (
                                        <span
                                          className={`${
                                            item?.status !==
                                              "DEPOSIT_WAITING" &&
                                            item?.status === "CANCELED" &&
                                            item?.paymentSuccessAt !== null
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          결제완료
                                        </span>
                                      )}
                                      {index + 1 === 3 && (
                                        <span
                                          className={`${
                                            item?.status !==
                                              "DEPOSIT_WAITING" &&
                                            item?.status !==
                                              "PAYMENT_COMPLETED" &&
                                            item?.status !== "CANCELED"
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          배송중
                                        </span>
                                      )}
                                      {index + 1 === 4 && (
                                        <span
                                          className={`${
                                            item?.status !==
                                              "DEPOSIT_WAITING" &&
                                            item?.status !==
                                              "PAYMENT_COMPLETED" &&
                                            item?.status !== "SHIPPING" &&
                                            item?.status !== "CANCELED"
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          배송완료
                                        </span>
                                      )}
                                      {index + 1 === 5 && (
                                        <span
                                          className={`${
                                            item?.status !==
                                              "DEPOSIT_WAITING" &&
                                            item?.status !==
                                              "PAYMENT_COMPLETED" &&
                                            item?.status !== "SHIPPING" &&
                                            item?.status !==
                                              "DELIVERY_COMPLETED" &&
                                            item?.status !== "CANCELED"
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          구매확정
                                        </span>
                                      )}
                                    </div>
                                  ) : null}

                                  {item?.status.includes("RETURNED") ? (
                                    <div>
                                      {index + 1 === 1 && (
                                        <span className="font-bold text-black">
                                          반품요청
                                        </span>
                                      )}
                                      {index + 1 === 2 && (
                                        <span
                                          className={`${
                                            item?.status.includes("RETURNED")
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          반품승인 검토
                                        </span>
                                      )}
                                      {index + 1 === 3 && (
                                        <span
                                          className={`${
                                            item?.returnAcceptAt !== null
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          반품배송(반송)
                                        </span>
                                      )}
                                      {index + 1 === 4 && (
                                        <span
                                          className={`${
                                            item?.status === "RETURNED_FINISH"
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          반품완료
                                        </span>
                                      )}
                                    </div>
                                  ) : null}

                                  {item?.status.includes("EXCHANGED") ? (
                                    <div>
                                      {index + 1 === 1 && (
                                        <span className="font-bold text-black">
                                          교환요청
                                        </span>
                                      )}
                                      {index + 1 === 2 && (
                                        <span
                                          className={`${
                                            item?.status.includes("EXCHANGED")
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          교환승인 검토
                                        </span>
                                      )}
                                      {index + 1 === 3 && (
                                        <span
                                          className={`${
                                            item?.status.includes(
                                              "EXCHANGED"
                                            ) &&
                                            (item?.status ===
                                              "EXCHANGED_SHIPPING" ||
                                              item?.status ===
                                                "EXCHANGED_SHIPPING_OFFICE" ||
                                              item?.status ===
                                                "EXCHANGED_FINISH")
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          교환배송(반송)
                                        </span>
                                      )}
                                      {index + 1 === 4 && (
                                        <span
                                          className={`${
                                            item?.status.includes("EXCHANGED") &
                                              item?.status.includes(
                                                "EXCHANGED"
                                              ) &&
                                            (item?.status ===
                                              "EXCHANGED_SHIPPING_OFFICE" ||
                                              item?.status ===
                                                "EXCHANGED_FINISH")
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          교환배송(본사)
                                        </span>
                                      )}

                                      {index + 1 === 5 && (
                                        <span
                                          className={`${
                                            item?.status.includes(
                                              "EXCHANGED"
                                            ) &&
                                            item?.status === "EXCHANGED_FINISH"
                                              ? "font-bold text-black"
                                              : ""
                                          }`}
                                        >
                                          교환배송완료(구매확정)
                                        </span>
                                      )}
                                    </div>
                                  ) : null}
                                </div>
                              </React.Fragment>
                            ))}
                          </div>
                          {item.status === "CANCELED" ? (
                            <div className="flex -mr-3">
                              {item.payment === "CANCELED" ||
                                (item.exchange === false && (
                                  <Button
                                    isDisabled={true}
                                    paddingButton="py-1"
                                    width="w-28"
                                    text={`무통장 입금완료`}
                                  />
                                ))}
                              <Modal
                                maxWidth="max-w-[29rem]"
                                padding="p-0"
                                widthButton="w-full py-1.5 mx-2"
                                widthSubmitButton="w-full py-1.5 mx-2"
                                title={`취소승인 검토`}
                                hasClose={true}
                                hasCancel={false}
                                cancelText="전체 다운로드"
                                submitText="취소요청"
                                paddingTitle={`px-4 pt-4`}
                                hasSubmit={false}
                                description={
                                  <PopupCancelOrder
                                    isSubmit={true}
                                    data={item?.complaints[0]}
                                    onSubmit={() =>
                                      handleApproveCancel(item?.productOrderId)
                                    }
                                    onRefuse={() =>
                                      handleRejectCancel(item?.productOrderId)
                                    }
                                  />
                                }
                                triggerClose={triggerCloseActionModal}
                              >
                                {item?.cancelRejectedAt === null &&
                                  item?.canceledAt === null && (
                                    <Button
                                      isDisabled={item?.canceledAt !== null}
                                      paddingButton="py-1"
                                      bgColor="bg-backdrop-red"
                                      textColorDefault="text-white"
                                      borderColor="border border-backdrop-red"
                                      width="w-20"
                                      text={`취소요청`}
                                    />
                                  )}
                                {item?.canceledAt !== null && (
                                  <Button
                                    isDisabled={item?.canceledAt !== null}
                                    paddingButton="py-1"
                                    bgColor="bg-backdrop-red"
                                    textColorDefault="text-white"
                                    borderColor="border border-backdrop-red"
                                    width="w-32"
                                    text={`${
                                      paidType === "ACCOUNT"
                                        ? "주문취소(무통장입금)"
                                        : "주문취소(신용카드)"
                                    } `}
                                  />
                                )}
                                {item?.cancelRejectedAt !== null ? (
                                  <Button
                                    isDisabled={item?.cancelRejectedAt !== null}
                                    paddingButton="py-1"
                                    bgColor="bg-backdrop-red"
                                    textColorDefault="text-white"
                                    borderColor="border border-backdrop-red"
                                    width="w-20"
                                    text={`주문취소 거부`}
                                  />
                                ) : null}
                              </Modal>
                            </div>
                          ) : (
                            ""
                          )}
                          {item.isCancel === "accepted" &&
                            item.exchange === false && (
                              <div className="-mr-2">
                                <Button
                                  isDisabled={true}
                                  width="w-32"
                                  text={
                                    item.payment === "deposit"
                                      ? `주문취소(무통장입금)`
                                      : `주문취소(신용카드)`
                                  }
                                />
                              </div>
                            )}
                          {item?.status?.includes("EXCHANGED") &&
                            item?.status !== "EXCHANGED_SHIPPING" &&
                            item?.status !== "EXCHANGED_SHIPPING_OFFICE" &&
                            item?.status !== "EXCHANGED_FINISH" && (
                              <div className="-mr-2">
                                <Modal
                                  maxWidth="max-w-[29rem]"
                                  padding="p-0"
                                  widthButton="w-full py-1.5 mx-2"
                                  widthSubmitButton="w-full py-1.5 mx-2"
                                  title={`교환승인 검토`}
                                  hasClose={true}
                                  hasCancel={false}
                                  cancelText="전체 다운로드"
                                  submitText="교환요청"
                                  paddingTitle={`px-4 pt-4`}
                                  hasSubmit={false}
                                  description={
                                    <PopupCancelOrder
                                      isSubmit={false}
                                      isExchange={true}
                                      data={item?.complaints?.[0]}
                                      onSubmit={() =>
                                        handleApproveExchange(
                                          item?.productOrderId
                                        )
                                      }
                                      onRefuse={() =>
                                        handleRejectExchange(
                                          item?.productOrderId
                                        )
                                      }
                                    />
                                  }
                                  triggerClose={triggerCloseActionModal}
                                >
                                  <Button
                                    isDisabled={
                                      item?.replaceRejectedAt !== null
                                    }
                                    paddingButton="py-1"
                                    bgColor="bg-backdrop-red"
                                    textColorDefault="text-white"
                                    borderColor="border border-backdrop-red"
                                    width={`${
                                      item?.replaceRejectedAt !== null
                                        ? "w-32"
                                        : "w-20"
                                    }`}
                                    text={`${
                                      item?.replaceRejectedAt !== null
                                        ? "교환거부(구매확정)"
                                        : "교환요청"
                                    }`}
                                  />
                                </Modal>
                              </div>
                            )}
                          {item.status === "EXCHANGED_FINISH" && (
                            <div className="-mr-2">
                              <Button
                                paddingButton="py-1"
                                isDisabled={true}
                                width="w-20"
                                text={`교환완료`}
                              />
                            </div>
                          )}
                          {item.status?.includes("EXCHANGED") &&
                            item?.status === "EXCHANGED_SHIPPING_OFFICE" && (
                              <div className="-mr-2">
                                <Modal
                                  maxWidth="max-w-[24.5rem]"
                                  padding={`px-6 py-4`}
                                  submitText="교환배송완료"
                                  cancelText="취소"
                                  widthSubmitButton="w-28"
                                  description={
                                    <div className="text-[11px] mb-8">
                                      해당 상품을 교환배송완료 처리하시겠습니까?
                                      배송완료를 해야만 최종적
                                      <br />
                                      으로 구매확정 처리됩니다.
                                      <br />
                                      <span className="text-[#e80000] mb-4">
                                        배송완료 이후, 수정이 불가능하오니,
                                        택배사로부터 배송이 완료되었는지
                                        <br /> 최종적으로 확인 후 진행
                                        부탁드립니다.
                                      </span>
                                      [유의사항 안내]
                                      <br />
                                      1. 상품이 최종적으로 고객에게 배송이
                                      완료된 것을 확인 후에 ‘배송완료’
                                      <br /> 처리 가능
                                      <br />
                                      2. 배송완료 처리 후,
                                      [구매확정/교환요청/반품요청] 전환됨
                                      <br />
                                      3. 구매확정
                                      <br />
                                      (1) 상품에 리뷰 포인트가 있는 경우,
                                      리뷰작성시 포인트 적립
                                      <br />
                                      (2) 리뷰는 구매확정 후 14일 경과하면 작성
                                      및 적립 불가
                                    </div>
                                  }
                                  onSubmit={() =>
                                    handleDeliveryExchangeFinish(
                                      item?.productOrderId
                                    )
                                  }
                                >
                                  <Button
                                    paddingButton="py-1"
                                    bgColor="bg-background-blue"
                                    textColorDefault="text-white"
                                    borderColor="border border-background-blue"
                                    width="w-32"
                                    text={`교환배송완료`}
                                  />
                                </Modal>
                              </div>
                            )}
                          {item.quantity === summedShipmentQty &&
                            item?.status === "SHIPPING" && (
                              <div className="flex -mr-3">
                                <Modal
                                  maxWidth="max-w-[24.5rem]"
                                  padding={`px-6 py-4`}
                                  submitText="배송완료"
                                  cancelText="취소"
                                  onSubmit={() =>
                                    handleCompleteDelivery(item?.productOrderId)
                                  }
                                  description={
                                    <div className="text-[11px] mb-8">
                                      해당 상품을 배송완료 처리하시겠습니까?
                                      배송완료를 해야만 고객이 구매
                                      <br />
                                      확정, 교환요청, 반품요청을 하실 수
                                      있습니다.
                                      <br />
                                      <span className="text-[#e80000] mb-4">
                                        배송완료 이후, 수정이 불가능하오니,
                                        택배사로부터 배송이 완료되었는지
                                        <br /> 최종적으로 확인 후 진행
                                        부탁드립니다.
                                      </span>
                                      [유의사항 안내]
                                      <br />
                                      1. 상품이 최종적으로 고객에게 배송이
                                      완료된 것을 확인 후에 ‘배송완료’
                                      <br /> 처리 가능
                                      <br />
                                      2. 배송완료 처리 후,
                                      [구매확정/교환요청/반품요청] 전환됨
                                      <br />
                                      3. 구매확정
                                      <br />
                                      (1) 고객이 ‘구매확정’처리 할 경우, 주문
                                      진행이 종료됨
                                      <br />
                                      (2) 상품에 리뷰 포인트가 있는 경우,
                                      리뷰작성시 포인트 부과
                                      <br />
                                      (3) 리뷰는 구매확정 후 14일 경과하면 작성
                                      및 적립 불가
                                      <br />
                                    </div>
                                  }
                                >
                                  <Button
                                    paddingButton="py-1"
                                    width="w-20"
                                    bgColor="bg-background-blue"
                                    borderColor="border border-background-blue"
                                    textColorDefault="text-white"
                                    text={`배송완료`}
                                  />
                                </Modal>

                                <Button
                                  paddingButton="py-1"
                                  isDisabled={true}
                                  width="w-20"
                                  text={`취소불가`}
                                />
                              </div>
                            )}
                          {item.status === "PURCHASE_CONFIRMED" && (
                            <div className="-mr-3">
                              <Button
                                paddingButton="py-1"
                                isDisabled={true}
                                width="w-20"
                                text={`구매확정`}
                              />
                              <Button
                                paddingButton="py-1"
                                isDisabled={true}
                                width="w-20"
                                text={`교환요청`}
                              />
                              <Button
                                paddingButton="py-1"
                                isDisabled={true}
                                width="w-20"
                                text={`반품요청`}
                              />
                            </div>
                          )}
                          {item.status === "RETURNED" && (
                            <div className="-mr-2">
                              <Modal
                                maxWidth="max-w-[29rem]"
                                padding="p-0"
                                widthButton="w-full py-1.5 mx-2"
                                widthSubmitButton="w-full py-1.5 mx-2"
                                title={`반품승인 검토`}
                                hasClose={true}
                                hasCancel={false}
                                cancelText="전체 다운로드"
                                submitText="교환요청"
                                paddingTitle={`px-4 pt-4`}
                                hasSubmit={false}
                                description={
                                  <PopupCancelOrder
                                    isSubmit={false}
                                    isExchange={false}
                                    isReturn={true}
                                    data={item?.complaints[0]}
                                    onSubmit={() =>
                                      handleApproveReturn(item?.productOrderId)
                                    }
                                    onRefuse={() =>
                                      handleRejectReturn(item?.productOrderId)
                                    }
                                  />
                                }
                                triggerClose={triggerCloseActionModal}
                              >
                                <Button
                                  isDisabled={
                                    item?.returnAcceptAt !== null ||
                                    item?.returnRejectedAt !== null
                                  }
                                  paddingButton="py-1"
                                  bgColor="bg-backdrop-red"
                                  textColorDefault="text-white"
                                  borderColor="border border-backdrop-red"
                                  width="w-32"
                                  text={`${
                                    item?.returnRejectedAt !== null
                                      ? "반품거부(구매확정)"
                                      : "반품요청"
                                  } `}
                                />
                              </Modal>
                            </div>
                          )}
                          {(item.status === "RETURNED" ||
                            item?.status === "RETURNED_SHIPPING" ||
                            item?.status === "RETURNED_FINISH") &&
                            item?.returnAcceptAt !== null && (
                              <div className="-mr-2">
                                <Modal
                                  maxWidth="max-w-[26rem]"
                                  padding="p-0"
                                  paddingTitle={`px-4 pt-4`}
                                  submitText={`${
                                    paidType === "ACCOUNT"
                                      ? "반품완료(무통장입금)"
                                      : "반품완료(신용카드)"
                                  }`}
                                  cancelText="취소"
                                  widthSubmitButton="w-auto"
                                  description={
                                    <>
                                      {paidType === "ACCOUNT" ? (
                                        <div className="px-4 py-2">
                                          반품 요청 받은 무통장입금이
                                          완료되었습니까? 완료되신 경우,
                                          <br />
                                          최종적으로 반품완료되어 환불 처리되며,
                                          반품정보가 등록됩니다.
                                        </div>
                                      ) : (
                                        <div className="px-4 py-2">
                                          신용카드 결제건에 대한 반품완료를
                                          진행하시겠습니까? 완료되신 경우, 최
                                          <br />
                                          종적으로 반품완료되어 환불 처리되며,
                                          반품정보가 등록됩니다.
                                        </div>
                                      )}
                                    </>
                                  }
                                  onSubmit={() =>
                                    handleFinishReturn(item?.productOrderId)
                                  }
                                >
                                  <Button
                                    isDisabled={
                                      item?.status === "RETURNED_FINISH"
                                    }
                                    paddingButton="py-1"
                                    width="w-32"
                                    bgColor="bg-background-blue"
                                    borderColor="border border-background-blue"
                                    textColorDefault="text-white"
                                    text={`${
                                      paidType === "ACCOUNT"
                                        ? "반품완료(무통장입금)"
                                        : "반품완료(신용카드)"
                                    }`}
                                  />
                                </Modal>
                              </div>
                            )}
                          {item.isCancel === "returned" && item.step === 4 && (
                            <div className="-mr-2">
                              <Button
                                paddingButton="py-1"
                                width="w-32"
                                isDisabled={true}
                                textColorDefault="text-white"
                                text={
                                  item.payment === "deposit"
                                    ? `반품완료(무통장입금)`
                                    : `반품완료(신용카드)`
                                }
                              />
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>

                    {index + 1 === productOrders?.length && (
                      <tr className="border font-bold border-disable-grey bg-input-grey">
                        <td colSpan={3} className="border py-2">
                          합계
                        </td>
                        <td className="border px-4">
                          {Math.round(
                            productOrders?.reduce(
                              (a, b) => a + b.paymentAmount,
                              0
                            )
                          ).toLocaleString("ko-KR")}
                        </td>
                        <td className="border">
                          {productOrders?.reduce((a, b) => a + b.quantity, 0)}
                        </td>
                        <td className="border">{summedAllShipmentQty}</td>
                        <td colSpan={3} className="border"></td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
          {/* <div className="flex justify-end text-[12px] mt-1">
            <p className="text-disable-black">
              ※ 상품 결제금액 : 상품의 '(정상 판매가 - 할인 판매가) x 주문 수량'
              계산된 금액 (포인트, 배송비 계산 전 금액)
            </p>
          </div> */}
        </>
      ) : (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center">
          등록된 주문내역이 없습니다.
        </div>
      )}
    </div>
  );
};

export default DetailTable;
